"use strict";
var Cache_1 = require('../Cache');
var MixinUtil_1 = require('../MixinUtil');
var GroupStore = (function () {
    function GroupStore() {
        // Cache impl
        this._cache = {};
    }
    return GroupStore;
}());
exports.GroupStore = GroupStore;
MixinUtil_1.default.applyMixins(GroupStore, [Cache_1.default]);
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = new GroupStore();
